import React from "react"
import { Link } from "gatsby"
import { animated } from "react-spring"

import Button from "../button/button"

import "./menu.sass"

const DEVELOPER = "https://www.concordpacific.com/"
const REGISTER = "https://theconcord.ca/Register/TheConcord.html"

const Menu = ({ style }) => {
  return (
    <animated.nav className="mobile-panel" style={style}>
      <div className="mobile-menu-wrapper">
        <div className="menu-section">
          <h1 className="menu-section-title">the concord</h1>
          <ul>
            <li>
              <Link to="/" activeClassName="menu-active">
                overview
              </Link>
            </li>
            <li>
              <Link to="/amenities/" activeClassName="menu-active">
                amenities
              </Link>
            </li>
            <li>
              <Link to="/floorplans/" activeClassName="menu-active">
                floorplans
              </Link>
            </li>
            <li>
              <Link to="/blog/" activeClassName="menu-active">
                news
              </Link>
            </li>
            <li>
              <Link to="/interiors/" activeClassName="menu-active">
                interiors
              </Link>
            </li>
            <li>
              <Link to="/gallery/" activeClassName="menu-active">
                gallery
              </Link>
            </li>
          </ul>
        </div>
        <div className="menu-section">
          <h1 className="menu-section-title">developer info</h1>
          <ul>
            <li>
              <a href={DEVELOPER}>concord pacific development</a>
            </li>
            <li>
              <Link to="/contact/" activeClassName="menu-active">
                contact us
              </Link>
            </li>
          </ul>
        </div>
        <div className="menu-section">
          <h1 className="menu-section-title">registration</h1>
          <Button href={REGISTER} cssClass="btn btn-secondary">
            register now
          </Button>
        </div>
      </div>
    </animated.nav>
  )
}

export default Menu
